import { Component, ElementRef, ViewContainerRef, ValueProvider, Renderer2, Injector, ChangeDetectionStrategy, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ComponentBase, IComponentBase, applyMixins, ComponentMixins, PropertyCollectionInfo, FormBase, setValue } from '@syncfusion/ej2-angular-base';
import { RadioButton } from '@syncfusion/ej2-buttons';



export const /** @type {?} */ inputs: string[] = ['checked','cssClass','disabled','enableHtmlSanitizer','enablePersistence','enableRtl','htmlAttributes','label','labelPosition','locale','name','value'];
export const /** @type {?} */ outputs: string[] = ['focus', 'blur', 'change','created','valueChange'];
export const /** @type {?} */ twoWays: string[] = ['value'];
/**
 * Represents the Angular RadioButton Component.
 * ```html
 * <ejs-radiobutton label='Default'></ejs-radiobutton>
 * ```
 */
@ComponentMixins([ComponentBase, FormBase])
export class RadioButtonComponent extends RadioButton implements IComponentBase {
public formCompContext : any;
public formContext : any;
public tagObjects: any;
public valueChange: any;
public focus: any;
public blur: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.formContext  = new FormBase();
        this.formCompContext  = new ComponentBase();
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnChange(registerFunction: (_: any) => void): void {
    }
/**
 * @param {?} registerFunction
 * @return {?}
 */
public registerOnTouched(registerFunction: () => void): void {
    }
/**
 * @param {?} value
 * @return {?}
 */
public writeValue(value: any): void {
    }
/**
 * @param {?} disabled
 * @return {?}
 */
public setDisabledState(disabled: boolean): void {
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.formCompContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.formContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.formCompContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.formCompContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-radiobutton',
    inputs: inputs,
    outputs: outputs,
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RadioButtonComponent),
            multi: true
        }
    ],
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function RadioButtonComponent_tsickle_Closure_declarations() {
/** @type {?} */
RadioButtonComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
RadioButtonComponent.ctorParameters;
/** @type {?} */
RadioButtonComponent.prototype.formCompContext;
/** @type {?} */
RadioButtonComponent.prototype.formContext;
/** @type {?} */
RadioButtonComponent.prototype.tagObjects;
/** @type {?} */
RadioButtonComponent.prototype.valueChange;
/** @type {?} */
RadioButtonComponent.prototype.focus;
/** @type {?} */
RadioButtonComponent.prototype.blur;
/** @type {?} */
RadioButtonComponent.prototype.registerEvents;
/** @type {?} */
RadioButtonComponent.prototype.addTwoWay;
/** @type {?} */
RadioButtonComponent.prototype.ngEle;
/** @type {?} */
RadioButtonComponent.prototype.srenderer;
/** @type {?} */
RadioButtonComponent.prototype.viewContainerRef;
/** @type {?} */
RadioButtonComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
